/**
 * Hardcoded booking UI / policy limits (see also {@code booking.BookingConstants} on the API).
 */

/** Maximum stay length: nights = calendar days from check-in to check-out (same as {@link dateUtils.getLengthOfStay}). */
export const MAX_RESERVATION_NIGHTS = 30;

/** Last bookable day is this many whole calendar months after “today” (start of local day). */
export const MAX_AVAILABILITY_MONTHS_AHEAD = 12;
